import { SchemaService } from 'libs/shared/src/services/forms/schemas/schema.service';
import { GsFormField, GsFormFieldPadding } from '../../../components';
import { ISides, ResponsiveAttribute } from '../../../models';

export const SPACING_SCHEMA: GsFormField<never>[] = [
  {
    formControlName: 'padding',
    label: 'schema.spacing.padding',
    type: 'padding',
    useTailwindClasses: true,
    isResponsive: true,
    default: {
      default: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      }
    }
  } as GsFormFieldPadding
];

/**
 * Returns the spacing schema with the specified default padding values.
 * @param defaultSpacing The default padding values to use in the schema.
 * @returns The spacing schema with the specified default padding values.
 */
export function getSpacingSchema(defaultSpacing: ResponsiveAttribute<ISides>): GsFormField<never>[] {
  const spacingSchema = [...SPACING_SCHEMA];
  const formField = spacingSchema.find((field) => field.formControlName === 'padding' && field.type === 'padding');
  if (formField && SchemaService.isGsFormFieldPadding(formField)) {
    formField.default = { ...formField.default, ...defaultSpacing };
  }
  return spacingSchema;
}
